import React from 'react';
import { string, bool, object } from 'prop-types';

import Styled from '../../utils/Styled';
import { BodyText, H3 } from '../Text/Heading';
import Wrapper from '../Wrapper';

const TaxContainer = Styled(Wrapper, {
  fontFamily: 'DM Sans',
});

const TaxTitle = Styled(H3, {
  fontFamily: 'DM Sans',
  fontWeight: 500,
});

const TaxBody = Styled(BodyText, {
  fontFamily: 'DM Sans',
  fontWeight: 400,
});

const mobileStyle = {
  container: {
    borderTop: '1px solid #D9DBE0',
  },
  text: {
    fontSize: 14,
  },
};

const desktopStyle = {
  container: {
    // just to keep parity
  },
  text: {
    fontSize: 12,
  },
};

export const MYTourismTax = ({
  title = '',
  body = '',
  isShown = true,
  mobile = false,
  wrapperStyle,
}) => {
  if (!isShown) {
    return null;
  }

  return (
    <TaxContainer
      style={{
        ...(mobile ? mobileStyle.container : desktopStyle.container),
        ...wrapperStyle,
      }}
    >
      <TaxTitle style={mobile ? mobileStyle.text : desktopStyle.text}>
        {title}
      </TaxTitle>
      <TaxBody style={mobile ? mobileStyle.text : desktopStyle.text}>
        {body}
      </TaxBody>
    </TaxContainer>
  );
};

MYTourismTax.propTypes = {
  title: string,
  body: string,
  isShown: bool,
  mobile: bool,
  wrapperStyle: object,
};
